import { Component } from '../../../libs/gin-tonic/helpers/compiler';

declare let ScrollMagic: any;
export const ScrollMagicController = new ScrollMagic.Controller();

@Component({ className: 'c-text-highlight' })
export class HighlightComponent {
	constructor(private element: HTMLElement) {
		new ScrollMagic.Scene({
			triggerElement: this.element,
			triggerHook: 0.6,
		})
			.setClassToggle(this.element, 'is-active')
			.addTo(ScrollMagicController)
	}
}
